module.exports = __webpack_public_path__ + "media/images/briefcase-icon-aeea9d181badb3ce4c5b3ceabbe4797f.png";